/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Logger, green } from "cms/utils/log/logger";
import { checkDiffs } from "utils/change-detection";
import Config from "data/config";

const mergeFields = (modifiedField, fields = []) => {

    if (Config.Logging.enableSavePipelineLog) {
        Logger.debug(green(`[mergeFields] fields length: ${fields.length}`));
    }
    
    // transform these fields into fields suitable for the API
    const modelFields = fields.map((original) => {
        
        const diffDetected = checkDiffs(original, modifiedField, "[mergeFields]");
        if (Config.Logging.enableSavePipelineLog) {
            Logger.debug(green("[mergeFields] test diff:"), { original, modified: modifiedField });
            Logger.debug(green(`[mergeFields] diffDetected: ${diffDetected}`));
        }
        
        const name = original?.name
        
        if (Config.Logging.enableSavePipelineLog) {
            Logger.debug(green(`[mergeFields] origninal: [${name}]`), original);
        }
        
        // is this the new field, or an unchanged field
        // - select field from modified or original
        const selected = (original.name === modifiedField.name) 
            ? modifiedField
            : original;
        
        const values = selected?.values;
        const settings = selected?.settings;
        const type = selected?.type;
        
        // TODO: start using the field settings
        // settings = {applyUnifiedSettings: false,hide: false,style: null,format: null,options: {} }

        const fieldObj = {
            name,
            type,
            settings,
            values,
        };
        if (Config.Logging.enableSavePipelineLog) {
            Logger.debug(green(`[mergeFields] [name: ${name}] object:`), { fieldObj });
        }
        
        return fieldObj;
    });

    if (Config.Logging.enableSavePipelineLog) {
        Logger.debug(green("[mergeFields] modelFields"), { modelFields });
    }
    return modelFields;
};

export { mergeFields };
